var activateOpenFacets = function activateOpenFacets(cookies) {
  return !!(cookies && cookies.get('MDM_TOOGLE_OPENFACETS'));
};

export default activateOpenFacets;